module.exports = __webpack_public_path__ + "static/media/237.1f8c0f5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/237.jpg
// module id = 961
// module chunks = 0